<template>
  <div id="app">
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
	<router-view></router-view>

  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
	body{
		/* height: 100vh; */
		background: #faf7f8;
		margin: 0;
		font-family: Microsoft Yahei,Heiti SC,tahoma,arial,Hiragino Sans GB,sans-serif;
	}
	
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center; */
  color: #2c3e50;
}
</style>
